export const mbPoUpload = {
  poUploadHeadline: {
    title: 'Quick and easy',
    heading1: 'Complete the form below with your information, upload your purchase order in .pdf format, and click submit.',
    heading2: 'Upon submission, your order will be forwarded to Customer Service for processing and confirmed via e-mail upon completion.'
  },
  poUploadForm: {
    firstName: 'First name',
    lastName: 'Last name',
    businessEmail: 'Business email',
    phoneNo: 'Phone no.',
    termsOfUse: 'I agree to the electronic storage and use of my data to enable my order to be processed. I agree to the ',
    privacyStatement: 'Privacy Statement.',
    uploadFile: 'Upload PO file (PDF) *',
    submit: 'Submit',
    mandatoryMissingError: 'Please fill in all mandatory fields.'
  },
  poUploadCart: {
    title: 'Speed up your order process',
    proceedToUploadForm: 'Upload purchase order',
    description: 'Click the button below to submit your PO.',
    confirmationTitle: 'Thank you for submitting your purchase order!',
    confirmationDetails: 'An order confirmation will be sent to you by email upon validation.',
    continueShopping: 'Continue shopping',
    viewOrderHistory: 'View order history'
  }
}
